import { type NextPage } from "next";
import Head from "next/head";

import AdminLayout from "../components/AdminLayout";
import { useRouter } from "next/dist/client/router";
import { useEffect } from "react";
import { useSession } from "next-auth/react";

const Home: NextPage = () => {
  const { data: session } = useSession();
  const router = useRouter();
  useEffect(() => {
    if (session) {
      router.push("/admin");
    }
  }, [session]);

  return (
    <>
      <Head>
        <title>Rohdemusik Druckfix</title>
        <meta name="description" content="Generated by create-t3-app" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <AdminLayout>
        <div></div>
      </AdminLayout>
    </>
  );
};

export default Home;
